import classnames from "classnames";
import * as PropTypes from "prop-types";
import React from "react";
import SVG from "react-inlinesvg";

import CheckIcon from "@krea/customer-features/images/svg/check-colorless.svg";

import styles from "./Icon.module.scss";

export const CheckMark = (className) => {
  return (
    <div
      className={classnames(
        "d-flex align-items-center justify-content-center border border-primary rounded-circle text-primary mr-2",
        className,
      )}
      style={{ width: "1.25rem", height: "1.25rem" }}
    >
      <div
        className="position-relative"
        style={{ width: "0.625rem", height: "0.625rem" }}
      >
        <SVG
          src={CheckIcon}
          className="position-absolute w-100 h-auto"
          style={{ top: 0, left: 0 }}
        />
      </div>
    </div>
  );
};

const Icon = ({ size, children, className }) => {
  return (
    <div
      className={classnames(
        styles.root,
        styles[size],
        "d-inline-block align-middle shrink-0 user-select-none",
        className,
      )}
    >
      {children}
    </div>
  );
};

Icon.propTypes = {
  size: PropTypes.oneOf(["sm", "md", "lg", "xl"]),
};

Icon.defaultProps = {
  size: "md",
};

export default Icon;
